export default __webpack_public_path__ + "static/media/Diviner's Belt of Supreme Decree.e0ad8311.jpg";